<template>
    <v-layout row wrap>
        <v-flex xs12 class="telaDDR">
            <div class="header-step">

                <h3>DDR e detalhes da operação</h3>
                <p>Informe se o cliente possui DDR e demais detelhes da operação.</p>
            </div>
            <v-form v-model="validCampos">
                <v-layout row wrap>
                    <v-flex xs12 sm5>
                        <h4 class="primary--text">Possui DDR (Dispensa do Direito de Regresso) com algum embarcador?</h4>
                        <v-radio-group :disabled="disableDdr" required :rules="regras.apoliceAnteriores" v-model="dadosDetalhesOperacao.ddrEmbarcadorOpcao" row>
                            <v-radio 
                                color="primary" 
                                id="chkNaoPossuiDdrEmbarcador" 
                                ref="chkNaoPossuiDdrEmbarcador" 
                                label="Não" 
                                value="false">
                            </v-radio>
                            <v-radio 
                                color="primary" 
                                id="chkSimDdrEmbarcador" 
                                ref="chkSimDdrEmbarcador" 
                                label="Sim" 
                                value="true">
                            </v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-layout v-show="dadosDetalhesOperacao.ddrEmbarcadorOpcao == 'true'" row wrap>
                        <v-flex md4>
                            <v-btn block color="secondary" :disabled="disableDdr" @click="dialogPossuiDdr =true">ADICIONAR DDR</v-btn>
                        </v-flex> 
                        <v-flex md12>
                            <div class="data-table-ddr mb-4">
                                <v-data-table
                                    :headers="headersDdr"
                                    :items="listDrrAdicionado"
                                    class="elevation-0"
                                    hide-actions
                                    >
                                    <template v-slot:no-data >
                                        <p></p>
                                    </template>
                                    <template v-slot:items="props">
                                        <td>
                                            {{ props.item.embarcador }}
                                        </td>
                                        <td>
                                            {{ props.item.seguradora }}
                                        </td>
                                        <td>
                                            {{ formatarData(props.item.dataVencimento) }}
                                        </td>
                                        <td>
                                            {{ formatMoney(props.item.valorTransportadoMes) }}
                                        </td>
                                        <td>
                                            {{ formatPossuiRCTRC(props.item.possuiApoliceRCTRC) }}
                                        </td>
                                        <td class="justify-center layout px-0">
                                            <v-icon
                                                small
                                                :disabled="disableDdr"
                                                class="mr-2"
                                                @click="editarItem(props.item)"
                                            >
                                                edit
                                            </v-icon>
                                            <v-icon
                                                small
                                                :disabled="disableDdr"
                                                @click="deletarItemDdr(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm5>
                        <h4 class="primary--text">Realiza operações com containers?*</h4>
                        <v-radio-group :disabled="disableDdr" required :rules="regras.apoliceAnteriores" v-model="dadosDetalhesOperacao.container" row>
                            <v-radio color="primary" id="chkNaoSegurosAnterioresApolicesAnteriores" ref="chkNaoSegurosAnterioresApolicesAnteriores" label="Não" value="false"></v-radio>
                            <v-radio color="primary" id="chkSimSegurosAnterioresApolicesAnteriores" ref="chkSimSegurosAnterioresApolicesAnteriores" label="Sim" value="true"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 sm5>
                        <h4 class="primary--text">Realiza operações de transporte fluvial?*</h4>
                        <v-radio-group :disabled="disableDdr" required :rules="regras.apoliceAnteriores" v-model="dadosDetalhesOperacao.fluvial" row>
                            <v-radio color="primary" id="chkNaoSegurosAnterioresApolicesAnteriores" ref="chkNaoSegurosAnterioresApolicesAnteriores" label="Não" value="false"></v-radio>
                            <v-radio color="primary" id="chkSimSegurosAnterioresApolicesAnteriores" ref="chkSimSegurosAnterioresApolicesAnteriores" label="Sim" value="true"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 sm5>
                        <h4 class="primary--text">Imposto suspenso e/ou benefícios internos?</h4>
                        <v-radio-group :disabled="disableDdr" required :rules="regras.apoliceAnteriores" v-model="dadosDetalhesOperacao.impostos" row>
                            <v-radio color="primary" id="chkNaoSegurosAnterioresApolicesAnteriores" ref="chkNaoSegurosAnterioresApolicesAnteriores" label="Não" value="false"></v-radio>
                            <v-radio color="primary" id="chkSimSegurosAnterioresApolicesAnteriores" ref="chkSimSegurosAnterioresApolicesAnteriores" label="Sim" value="true"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 sm8>
                        <h4 class="primary--text">Documentos utilizados para comprovação do valor da mercadoria:</h4>
                        <v-layout>
                            <v-flex xs11 sm10 md11 lg10 xl6>
                                <v-select
                                    label="Tipo do documento"
                                    id="txtTipoDoDocumento"
                                    ref="txtSelectDocumento"
                                    v-model="modelDocumento.tipoDocumento"
                                    item-text="titulo"
                                    item-value="titulo"
                                    placeholder="Selecione uma opção"
                                    :items="exibeDocumentoTransportador ? listTipoDocumentoTransportador : listTipoDocumentoEmbarcador"
                                    :disabled="disableDdr"
                                    multiple
                                >
                                </v-select>
                                <v-text-field 
                                    v-if="exibeOpcaoOutro()"
                                    label="Especifique o tipo" 
                                    v-model="modelDocumento.outroTipoDocumento"
                                    :rules="regras.outroDocumento"
                                    :disabled="disableDdr"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs4 md3>
                        <v-btn flat @click="$emit('voltarDetalhesOperacao', true)" color="primary">
                            Voltar
                        </v-btn>
                    </v-flex>
                    <v-flex xs4 md3>
                        <v-btn
                            :disabled="validarPassoDdr"
                            @click="clickProximoDdr"
                            color="primary"
                        >
                            proximo
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-flex>
        <v-dialog v-model="dialogPossuiDdr" persistent max-width="500px">
            <v-card>
                <v-card-title>
                {{ editedIndex > -1 ? "Editar" : "Adicionar"}} DDR
                </v-card-title>
                <v-card-text>
                    <v-form ref="modelDdrForm" v-model="formAdicionarDdr">
                        <v-text-field 
                            label="Embarcador" 
                            v-model="ddrModel.embarcador"
                            :rules="regras.apoliceAnteriores"
                        >
                        </v-text-field>
                        <v-text-field 
                            label="Seguradora" 
                            v-model="ddrModel.seguradora"
                        >
                        </v-text-field>
                        <v-menu
                            v-model="menuData"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="dataVencimentoComputada"
                                    label="Data do Vencimento"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="ddrModel.dataVencimento" no-title @input="menuData = false"></v-date-picker>
                        </v-menu>
                        <v-text-field 
                            label="Valor transportado ao mês" 
                            v-model="valorTransportadoMesFiltrado"
                            ref="valorTransportado"
                            v-money="maskComputed.maskMoney"
                        >
                        </v-text-field>
                        <h4 class="primary--text">Possui Apólice estipulada RCTR-C?</h4>
                        <v-radio-group :disabled="disableDdr" required :rules="regras.apoliceAnteriores" v-model="ddrModel.possuiApoliceRCTRC" row>
                            <v-radio color="primary" id="chkNaoApoliceRctrc" ref="chkNaoApoliceRctrc" label="Não" value="false"></v-radio>
                            <v-radio color="primary" id="chkSimApoliceRctrc" ref="chkSimApoliceRctrc" label="Sim" value="true"></v-radio>
                        </v-radio-group>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn flat color="primary" @click="tratamentoFecharDialogAdicionarDdr">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" :disabled="!formAdicionarDdr" @click="tratamentoSalvarDialogAdicionarDdr">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
    import {VMoney} from 'v-money'
    import CustomFormat from '@/helpers/custom-format'
    import usuarioHelper from "@/helpers/usuario-logado";
    import axios from 'axios'
    import mask from "@/helpers/mask"
    import TipoCliente from '@/helpers/tipo-cliente'

    export default {
        name: 'QARDDR',
        directives: {
        money: VMoney
    },
    props: {
        protocolo: String,
        dadosQuestionarioCompleto: {
            type: Object, 
            required: false,
        },
        dadosCadastrais: {
            type: Object, 
            required: false,
        }
    },
    data: () => {
        return {
            menuData: false,
            editedIndex: -1,
            defaultItemDDR: {
                embarcador: null, 
                seguradora: null, 
                dataVencimento: null,
                possuiApoliceRCTRC: null, 
                valorTransportadoMes: null, 
            },
            dialogPossuiDdr: false, 
            listDrrAdicionado: [],
            formAdicionarDdr: true,
            dadosDetalhesOperacao: {
                ddrEmbarcadorOpcao: "false", 
                fluvial: "false",
                container: "false",
                impostos: "false",
                ddrEmbarcador: {},
            },
            ddrModel: {
                embarcador: null, 
                seguradora: null, 
                dataVencimento: null,
                possuiApoliceRCTRC: null, 
                valorTransportadoMes: null, 
            },
            valorTransportadoMesFiltrado: null,  
            questionarioPai: {},
            ddr: null,
            Impostos:null,
            fluvial: null,
            container: null,
            validCampos: true,
            dataHoraInicio: '',
            tempoPreenchimentoTotal: '',
            formValidSegurosAnteriores: false,
            formValidSegurosAnterioresSinistros: false,
            modalDataVencimento: false,
            modalDataSinistro: false,
            apoliceAnterioresStr: null,
            taxaDescontoAnteriorRadioStr: null,
            coberturaRouboStr: null,
            ocorreuSinistroStr: null,
            listTipoDocumento: [],
            listTipoDocumentoTransportador: [],
            listTipoDocumentoEmbarcador: [],
            exibeDocumentoTransportador: false,
            modelDocumento: {
                tipoDocumento: [],
                outroTipoDocumento: null,
            },
            lstOpcoesCausaDoSinistro: [
                {id: 1, causaDoSinistro: 'Acidente'},
                {id: 2, causaDoSinistro: 'Avaria'},
                {id: 3, causaDoSinistro: 'Roubo'}        
            ],
            modelFormatado: {
                dataVencimento: '',
                valorPrejuizoSinistro: 0.0,
                dataSinistro: '',
                taxaApoliceAnterior: 0.0,
                descontoApoliceAnterior: "0",
                taxaRouboApoliceAnterior: "0"
            },
            modelSinistro: {
                valorPrejuizo: 0.0,
                mercadoria: {},
                causaDoSinistro: '',
                data: '',
                estado: null,
                cidade: null,
                obs: null
            },
            segurosAnteriores: {
                apoliceAnteriores: null,
                seguradora: '',
                corretora: '',
                vencimento: '',
                ocorreuSinistro: null,
                sinistros: [],

            coberturaRoubo: null,
                taxaApoliceAnterior: 0.0,
                descontoApoliceAnterior: 0.0,
                taxaRouboApoliceAnterior: 0.0
            },
            cabecalhoGridSinistros: [
                { text: 'Mercadoria', value: 'mercadoria'},
                { text: 'Valor do prejuízo', value: 'valorPrejuizo'},
                { text: 'Causa do Sinistro', value: 'causaDoSinistro'},
                { text: 'Data', value: 'data'},
                {text: '', value: ''}
            ],
            errorMessages: {
                valorPrejuizo: [],
                mercadoria: [],
                causaDoSinistro: [],
                estado: [],
                cidade: [],
                data: [],
                obs: []
            },
            regras: {
                precisaTerValor: [
                  v => ( v != "R$ 0,00"  && !!v) || 'Valor nao pode ser 0 e precisa estar preenchido'  
                ],
                apoliceAnteriores: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                seguradora: [
                v => !!v || 'Você não pode deixar este campo em branco'
                ],
                corretora: [
                v => (!v || (!!v && (v.length == 0 || v.length <= 255))) || 'O campo deve ter no máximo 255 caracteres'
                ],
                taxaDescontoAnteriorRadio: [
                v => !!v || 'Você não pode deixar este campo em branco'
                ],
                ocorreuSinistro: [
                v => !!v || 'Você não pode deixar este campo em branco'
                ],
                porcentagemTaxa: [
                v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                    v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                    v => (   (/^(100)$/g.test(v) && v.length < 8 )
                            || (/^(100\,\d{1,3})$/g.test(v) && v.length < 8 )
                            || (/^(\d{2})$/g.test(v) && v.length < 7)
                            || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                            || (/^(\d{1})$/g.test(v) && v.length < 6)
                            || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                            || 'Você precisa informar um valor válido'
                ],
                porcentagemDesconto: [
                v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                v => (   (/^(100)$/g.test(v) && v.length < 8 )
                        || (/^(100\,\d{1,2})$/g.test(v) && v.length < 8 )
                        || (/^(\d{2})$/g.test(v) && v.length < 6)
                        || (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6)
                        || (/^(\d{1})$/g.test(v) && v.length < 5)
                        || (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) )
                        || 'Você precisa informar um valor válido'
                ],
                valorPrejuizo: [
                v => CustomFormat.removeMoneyFormat(v) > 0 || "Você precisa informar um valor válido"
                ],

                descontoApoliceAnterior: [
                    v => (CustomFormat.removePercentFormat(v) >= 0 &&
                        CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um desconto válido'
                ],
                taxaApoliceAnterior: [
                    v => (CustomFormat.removePercentFormat(v) > 0 &&
                        CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar uma taxa válida'
                ],
                coberturaRoubo: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                outroDocumento: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                taxaRouboApoliceAnterior: [
                    v => (CustomFormat.removePercentFormat(v) > 0 && 
                        CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar uma taxa válida'
                ]
            },
            headersDdr: [
                { text: "Embarcador",width: "50px", value: "embarcador", align:"center", sortable: false },
                { text: "Seguradora", value: "seguradora",width: "50px", align:"center", sortable: false },
                { text: "Vencimento", width: "50px", value: "datavencimento", align:"center", sortable: false },
                { text: "Valor transp. mês", width: "40px", value: "datavencimento", align:"center", sortable: false },
                { text: "Estipula RCTR-C", width: "50px", value: "rctrc", align:"center", sortable: false },
                { text: "Ações", width: "50px", value: "acao", align:"center", sortable: false },
            ],
            maskMoney: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            }
        }
        },
        computed: {
            tipoClienteComputed: function () {
                return TipoCliente;
            },
            disableDdr() {
                return this.protocolo != null || this.dadosQuestionarioCompleto.id != null;
            },
            validarPassoDdr() {
                if(this.validCampos && this.dadosDetalhesOperacao.ddrEmbarcadorOpcao == "false") {
                    return false
                } 
                if(this.validCampos && this.dadosDetalhesOperacao.ddrEmbarcadorOpcao == "true" && this.listDrrAdicionado.length > 0) {
                    return false
                }

                return true;
            },
            maskComputed: function() {
                return mask;
            },
            dataVencimentoComputada () {
                return this.formatarData(this.ddrModel.dataVencimento)
            },
            elementoPai: function () {
                return this.$parent.$parent.$parent;
            },
            taxaApoliceAnteriorValid: function () {
                return this.segurosAnteriores.taxaApoliceAnterior > 0 && this.segurosAnteriores.taxaApoliceAnterior <= 100;
            },
            descontoApoliceAnteriorValid: function () {
                return this.segurosAnteriores.descontoApoliceAnterior > 0 && this.segurosAnteriores.descontoApoliceAnterior <= 100;
            },
            sinistroValido: function() {
                return this.modelSinistro.valorPrejuizo && this.modelSinistro.mercadoria && this.modelSinistro.causaDoSinistro && this.modelSinistro.data;
            },
            passoValido: function () {
                const self = this;
                let validaOcorrenciaSinistro = (self.segurosAnteriores.ocorreuSinistro && self.segurosAnteriores.sinistros.length > 0) || !self.segurosAnteriores.ocorreuSinistro;
                if (self.apoliceAnterioresStr == 'true'){        
                    self.formValidSegurosAnteriores = 
                        self.segurosAnteriores.seguradora != "" && 
                        self.segurosAnteriores.corretora.length <= 255 &&
            
                        (self.taxaDescontoAnteriorRadioStr != null && //Desativação da taxa e desconto
                        ((self.segurosAnteriores.descontoApoliceAnterior >= 0 && self.segurosAnteriores.descontoApoliceAnterior <=100 && self.taxaDescontoAnteriorRadioStr == 'desconto') || 
                        (self.segurosAnteriores.taxaApoliceAnterior > 0 && self.segurosAnteriores.taxaApoliceAnterior <= 100  && self.taxaDescontoAnteriorRadioStr == 'taxa'))) &&
                        self.segurosAnteriores.coberturaRoubo != null && 
                        ((self.segurosAnteriores.taxaRouboApoliceAnterior > 0 && self.segurosAnteriores.taxaRouboApoliceAnterior <= 100 && self.segurosAnteriores.coberturaRoubo == true) || 
                        self.segurosAnteriores.coberturaRoubo == false) &&
                        (self.segurosAnteriores.ocorreuSinistro != null &&
                        ((self.segurosAnteriores.sinistros.length > 0) || self.segurosAnteriores.ocorreuSinistro == false));            
                } else {
                    self.formValidSegurosAnteriores = 
                        (((self.segurosAnteriores.ocorreuSinistro && self.segurosAnteriores.sinistros.length > 0) ||
                        !self.segurosAnteriores.ocorreuSinistro) && self.apoliceAnterioresStr == 'false');
                }
                if (self.apoliceAnterioresStr == null || self.ocorreuSinistroStr == null) {
                    self.formValidSegurosAnteriores = false;
                }
                return this.formValidSegurosAnteriores && validaOcorrenciaSinistro;
            }
        },
        watch: {
            dadosQuestionarioCompleto(val) {
                if(val.id != null  &&  val.id != undefined) {
                    this.buscarTransportadora(val.idTransportadora);
                    this.dadosDetalhesOperacao.ddrEmbarcadorOpcao = val.dadosOperacionais.ddrEmbarcadorOpcao ? "true" : "false";
                    this.dadosDetalhesOperacao.container = val.dadosOperacionais.container ? "true" : "false";
                    this.dadosDetalhesOperacao.container = val.dadosOperacionais.fluvial ? "true" : "false";
                    this.dadosDetalhesOperacao.container = val.dadosOperacionais.impostos ? "true" : "false";
                    if (val.dadosOperacionais.tipoDocumento != null || val.dadosOperacionais.tipoDocumento != undefined) {
                        this.modelDocumento.tipoDocumento = val.dadosOperacionais.tipoDocumento.split(",")
                    }
                    this.modelDocumento.outroTipoDocumento = val.dadosOperacionais.outroTipoDocumento ?
                        val.dadosOperacionais.outroTipoDocumento : null;
                    this.listDrrAdicionado = val.dadosOperacionais.ddrEmbarcador;

                }
            },
            dadosCadastrais(val) {
                if(val.transportadora.tipoCliente.id != null && val.transportadora.tipoCliente.id != undefined) {
                    if (val.transportadora.tipoCliente.id == this.tipoClienteComputed.tipoCliente.TRANSPORTADOR) {
                        this.exibeDocumentoTransportador = true;
                    }
                }
            },
            valorTransportadoMesFiltrado(val) {
                if(val != null && val != undefined && val!= "") {
                    this.ddrModel.valorTransportadoMes = CustomFormat.removeMoneyFormat(val);
                }
            },
            apoliceAnterioresStr: function (val) {
                this.segurosAnteriores.apoliceAnteriores = val == 'true';
                if (val == 'false') {
                    this.resetFormApoliceAnterior();
                }
            },
            taxaDescontoAnteriorRadioStr: function (val) { //Desativação dos campos taxa e desconto
                if (val == 'taxa') {
                    this.modelFormatado.descontoApoliceAnterior = "0";
                    this.segurosAnteriores.descontoApoliceAnterior = 0.0;
                } else if (val == 'desconto') {
                    this.modelFormatado.taxaApoliceAnterior = "0";
                    this.segurosAnteriores.taxaApoliceAnterior = 0.0;
                } else {
                    this.modelFormatado.taxaApoliceAnterior = "0";
                    this.segurosAnteriores.taxaApoliceAnterior = 0.0;
                    this.modelFormatado.descontoApoliceAnterior = "0";
                    this.segurosAnteriores.descontoApoliceAnterior = 0.0;
                }
            },
            coberturaRouboStr: function (val) {
                const self = this;
                switch (val) {
                    case 'true':
                        self.segurosAnteriores.coberturaRoubo = true;
                        break;
                    case 'false':
                        self.segurosAnteriores.taxaRouboApoliceAnterior = 0.0;
                        self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.$el.getElementsByTagName('input')[0].value = 0.00;
                        self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.reset();
                        self.segurosAnteriores.coberturaRoubo = false;
                        break;
                    default:
                        self.segurosAnteriores.coberturaRoubo = null;
                        break;
                }
            },
            ocorreuSinistroStr: function (val) {
                this.segurosAnteriores.ocorreuSinistro = val == 'true';
            },
            'segurosAnteriores.vencimento': function (val) {
                this.modelFormatado.dataVencimento = CustomFormat.toLocaleDateString(val);
            },
            'modelFormatado.taxaApoliceAnterior': function (val) {
                this.segurosAnteriores.taxaApoliceAnterior = CustomFormat.removePercentFormat(val);
            },
            'modelFormatado.descontoApoliceAnterior': function (val) {
                this.segurosAnteriores.descontoApoliceAnterior = CustomFormat.removePercentFormat(val);
            },
            'modelFormatado.taxaRouboApoliceAnterior': function (val) {
                this.segurosAnteriores.taxaRouboApoliceAnterior = CustomFormat.removePercentFormat(val);
            },
            'modelFormatado.valorPrejuizoSinistro': function (val) {
                this.modelSinistro.valorPrejuizo = CustomFormat.removeMoneyFormat(val);
            },
            'modelSinistro.data': function (val) {
                this.modelFormatado.dataSinistro = val ? CustomFormat.toLocaleDateString(val) : '';
            },
            'dadosDetalhesOperacao.ddrEmbarcadorOpcao': function (val) {
                if (this.dadosDetalhesOperacao.ddrEmbarcadorOpcao == "false") {
                    this.limparGridDdr();
                }
            },
            'modelDocumento.tipoDocumento': function (val) {
                if (val.includes("Outro(s)") == false) {
                    this.modelDocumento.outroTipoDocumento = null;
                }
            }
        },
        mounted: function () {
            this.$refs.modelDdrForm.reset();
            this.resetDataHoraInicio();
            this.carregaTipoDocumento();
        },
        methods: {
            exibeOpcaoOutro() {
                for (let x of this.modelDocumento.tipoDocumento) {
                    if (x == "Outro(s)") {
                        return true
                    }
                }
            },
            clickProximoDdr() {
                this.dadosDetalhesOperacao.ddrEmbarcadorOpcao = this.dadosDetalhesOperacao.ddrEmbarcadorOpcao;
                this.dadosDetalhesOperacao.ddrEmbarcador = this.listDrrAdicionado;
                this.dadosDetalhesOperacao.tipoDocumento = this.modelDocumento.tipoDocumento 
                    ? this.modelDocumento.tipoDocumento.toString() : null;
                this.dadosDetalhesOperacao.outroTipoDocumento = this.modelDocumento.outroTipoDocumento;
                this.$emit('dadosDetalhesOperacao', this.dadosDetalhesOperacao);
            },
            editarItem(item) {
            
                this.editedIndex = this.listDrrAdicionado.indexOf(item)
                this.$refs.valorTransportado.$el.getElementsByTagName('input')[0].value = item.valorTransportadoMes.toFixed(2);

                this.ddrModel = Object.assign({}, item)
                this.dialogPossuiDdr = true
        
            },
            deletarItemDdr(item) {
            
                const index = this.listDrrAdicionado.indexOf(item)
                this.listDrrAdicionado.splice(index, 1);
            },
            formatPossuiRCTRC(val) {
                if(val =! null && val ==  true || val == "true") {
                    return "Sim"
                } 
                return "Nao"
                
            },  
            formatMoney(amount) {
            return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(amount || 0);
            },
            tratamentoSalvarDialogAdicionarDdr() {
                const auxProp = {...this.ddrModel};
                auxProp.dataVencimento = this.ddrModel.dataVencimento;
                if(this.editedIndex  > -1) {
                    Object.assign(this.listDrrAdicionado[this.editedIndex], auxProp)
                    
                } else {
                    this.listDrrAdicionado.push(auxProp);
                }
                this.tratamentoFecharDialogAdicionarDdr();
            },
            limparDadosDdr() {
                this.ddrModel.embarcador = null;
                this.ddrModel.seguradora = null;
                this.valorTransportadoMesFiltrado = 0.00;
                this.$refs.valorTransportado.$el.getElementsByTagName('input')[0].value = 0;
                this.ddrModel.dataVencimento = null;
                this.ddrModel.possuiApoliceRCTRC = null;
                this.ddrModel.valorTransportadoMes = null;
                this.editedIndex = -1;
                this.$refs.modelDdrForm.reset();
                this.$refs.modelDdrForm.resetValidation();
            
            },
            limparGridDdr() {
                this.listDrrAdicionado.splice(0);
            },
            tratamentoFecharDialogAdicionarDdr() {
                this.limparDadosDdr();
                this.dialogPossuiDdr= false;
            },
            formatarData (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
                
            },
        usarQuestionarioPai: function (param) {
            const self = this;
            self.questionarioPai = param;        
            self.segurosAnteriores = self.questionarioPai;
            self.apoliceAnterioresStr = self.questionarioPai.apolicesAnteriores.toString();
    
            if (self.apoliceAnterioresStr == 'true') {
                if (self.questionarioPai.taxaApoliceAnterior > 0) {
                    self.taxaDescontoAnteriorRadioStr = 'taxa';
                    self.modelFormatado.taxaApoliceAnterior = CustomFormat.pontoParaVirgula(self.questionarioPai.taxaApoliceAnterior.toFixed(3));
                } else if(self.questionarioPai.descontoApoliceAnterior) { //Desativação dos campos taxa e desconto
                    self.taxaDescontoAnteriorRadioStr = 'desconto';
                    self.modelFormatado.descontoApoliceAnterior = CustomFormat.pontoParaVirgula(self.questionarioPai.descontoApoliceAnterior.toFixed(2));
                }
                if (self.questionarioPai.taxaRouboApoliceAnterior > 0) {
                    self.coberturaRouboStr = 'true';
                    self.modelFormatado.taxaRouboApoliceAnterior = CustomFormat.pontoParaVirgula(self.questionarioPai.taxaRouboApoliceAnterior.toFixed(3));
                } else {
                    self.coberturaRouboStr = 'false';
                }
            }
            self.ocorreuSinistroStr = self.questionarioPai.ocorreuSinistro.toString();      
        },
        getEstadoCidadePorId: async function () {
            const self = this;
            var idEstado;
            var idCidade;
            for (var i = 0; i < self.segurosAnteriores.sinistros.length; i++) {
                idEstado = self.segurosAnteriores.sinistros[i].estado;
                idCidade = self.segurosAnteriores.sinistros[i].cidade;
    
                await axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaEstado?id=${idEstado}`)
                .then((response) => {
                    self.segurosAnteriores.sinistros[i].estado = response.data;
                });
                
                await axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaCidadePorId?idcidade=${idCidade}`)
                .then((response) => {
                    self.segurosAnteriores.sinistros[i].cidade = response.data.cidadeModel;
                });
            }
        },
        resetDataHoraInicio: function () {
            this.dataHoraInicio = new Date();
        },
        somaTempoPreenchimentoTotal: function () {
            const self = this;
            var dateTimeNow = new Date();
            if (self.tempoPreenchimentoTotal == '') {
                self.tempoPreenchimentoTotal = parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60));
            } else {
                self.tempoPreenchimentoTotal += (parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60)));
            }
        },
        carregaTipoDocumento: function() {
            const self = this;

            axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/tipoDocumento`, {
                headers: {
                    'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            }).then(response => {
                this.listTipoDocumentoTransportador = response.data.filter(this.retornaDocumentosTransportador);
                this.listTipoDocumentoEmbarcador = response.data.filter(this.retornaDocumentosEmbarcador);

            }).catch((err) => {
                console.log(err);
            });;
        },
        buscarTransportadora(val) {
            axios.get(`${process.env.URL_TRANSPORTADORAMS}/v1/buscaTransportadora?id=${val}`, {
                headers: {
                    'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            }).then(res => {
                if(res.data) {
                    if (res.data.tipoCliente.id == this.tipoClienteComputed.tipoCliente.TRANSPORTADOR) {
                        this.exibeDocumentoTransportador = true
                    }
                }
            })
        },
        retornaDocumentosTransportador(value) {
            if (value.id <= 7) {
                return value;
            }
        },
        retornaDocumentosEmbarcador(value) {
            if (value.id >= 7) {
                return value;
            }
        },
        toMoneyString: function (val) {
            return CustomFormat.toMoneyString(val);
        },
        toLocaleDateString: function (val) {
            return CustomFormat.toLocaleDateString(val);
        },
        removeSinistro: function (item) {
            let index = this.segurosAnteriores.sinistros.indexOf(item);
            this.segurosAnteriores.sinistros.splice(index, 1);
        },
        validaAddSinistro: function () {
            const self = this;
            let erro = false;
            
            self.errorMessages.valorPrejuizo = [];
            if (self.modelSinistro.valorPrejuizo == 0) {
                erro = erro || true;
                self.errorMessages.valorPrejuizo = ['Você precisa informar um valor válido'];
            }
    
            self.errorMessages.mercadoria = [];
            if (Object.keys(self.modelSinistro.mercadoria).length === 0) {
                erro = erro || true;
                self.errorMessages.mercadoria = ['Você não pode deixar este campo em branco'];
            }
    
            self.errorMessages.causaDoSinistro = [];
            if (!self.modelSinistro.causaDoSinistro) {
                erro = erro || true;
                self.errorMessages.causaDoSinistro = ['Você não pode deixar este campo em branco'];
            }
    
            self.errorMessages.data = [];
            if (!self.modelSinistro.data) {
                erro = erro || true;
                self.errorMessages.data = ['Você não pode deixar este campo em branco'];
            }
    
            return !erro;
        },
        limpaCamposSinistro: function () {
            const self = this;
            self.modelSinistro.mercadoria = {};
            self.modelSinistro.causaDoSinistro = '';
            self.modelSinistro.data = '';
            self.modelSinistro.estado = null;
            self.modelSinistro.cidade = null;
            self.modelSinistro.obs = null;
            self.$refs.txtValorSinistro.$el.getElementsByTagName('input')[0].value = 0;
        },
        adicionaSinistro: function () {
            const self = this;
    
            if (self.validaAddSinistro()) {
                self.segurosAnteriores.sinistros.push(Object.assign({}, self.modelSinistro));
                self.limpaCamposSinistro();
            }
        },
        montaModelo: function () {
            const self = this;
            let modelo = {};
    
            modelo.apolicesAnteriores = self.segurosAnteriores.apoliceAnteriores;
            if (modelo.apolicesAnteriores) {
                modelo.seguradora = self.segurosAnteriores.seguradora;
                modelo.corretora = self.segurosAnteriores.corretora;
                modelo.vencimento = self.segurosAnteriores.vencimento;
                modelo.coberturaRoubo = self.segurosAnteriores.coberturaRoubo;
                modelo.taxaApoliceAnterior = self.segurosAnteriores.taxaApoliceAnterior;
                modelo.descontoApoliceAnterior = self.segurosAnteriores.descontoApoliceAnterior;
    
                if (modelo.coberturaRoubo){
                    modelo.taxaRouboApoliceAnterior = self.segurosAnteriores.taxaRouboApoliceAnterior;
                }
            }
    
            modelo.ocorreuSinistro = self.segurosAnteriores.ocorreuSinistro;
            if (modelo.ocorreuSinistro) {
                modelo.sinistros = self.segurosAnteriores.sinistros;
            }
    
            return modelo;
        },
        zeraTaxaDescontoAnteriorTextField: function () { //Desativação dos campos taxa e desconto
            const self = this;
            if (self.taxaDescontoAnteriorRadioStr == 'taxa') {
                if (!!document.getElementById('txtSegurosAnterioresDescontoApoliceAnterior')) {
                    self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.00;
                    self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.reset();
                }
            } else if (self.taxaDescontoAnteriorRadioStr == 'desconto') {
                if (!!document.getElementById('txtSegurosAnterioresTaxaApoliceAnterior')) {
                    self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.000;
                    self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.reset();
                }
            }
        },
        resetFormApoliceAnterior: function () {
            const self = this;
            self.segurosAnteriores.apoliceAnteriores = false;
            
            self.$refs.txtSegurosAnterioresSeguradoraRef.reset();
            self.segurosAnteriores.seguradora = '';
            self.$refs.txtSegurosAnterioresCorretoraRef.reset();
            self.segurosAnteriores.corretora = '';
            
            self.segurosAnteriores.vencimento = null;
    
            self.segurosAnteriores.taxaApoliceAnterior = 0.0;
            self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.000;
            self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.reset();
            
            self.segurosAnteriores.descontoApoliceAnterior = 0.0;
            self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.00;
            self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.reset();
            
            self.$refs.taxaDescontoAnteriorRadioRef.reset();
            self.taxaDescontoAnteriorRadioStr = null; //Desativação dos campos taxa e desconto
            
            self.segurosAnteriores.taxaRouboApoliceAnterior = 0.0;
            self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.$el.getElementsByTagName('input')[0].value = 0.00;
            self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.reset();
        
            self.$refs.taxaRouboAnteriorRadioRef.reset();
            self.segurosAnteriores.coberturaRoubo = null;
            self.coberturaRouboStr = null;
        }
    }
}
</script>
<style>
    .QuestionarioAnaliseRiscos .telaDDR{
        margin-top: 32px;
        margin-left: 15px;
    }
    .telaDDR table.v-table tbody td {
        padding: 0 12px!important;
        text-align: center;
    }
    .telaDDR table.v-table tbody td:nth-child(1) {
        padding: 0!important;
    }
    .telaDDR .container.grid-list-md .layout:not(:only-child) {
        margin: auto 0!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARDDR.vue